import styled, { css } from 'styled-components';
import ModalWindow from 'components/modals/ModalWindow';
import {
  ACCENT_PRIMARY,
  HIGHLIGHT_PRIMARY,
  SURFACE_6,
  TEXT_100,
  TEXT_CONTRAST_ON_ACCENT_PRIMARY,
  TEXT_CONTRAST_ON_HIGHLIGHT_PRIMARY,
} from 'style/constants';
import { desktopOnly, mobileOnly } from 'style/mixins';
import Button from 'components/ui/Button';
import { TEXT_LABEL_M_BOLD, TEXT_LABEL_M_MEDIUM } from 'style/design-system/textStyles';
import { REJECT, SUBMIT } from 'injection-classes';
import Link from 'components/ui/Link';

// gdpr
export const StyledModalWindow = styled(ModalWindow)<{
  adminbarWidth: number;
  sidebarWidth: number;
}>`
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  z-index: 100;
  padding: 0;
  display: flex;
  justify-content: center;
  background: transparent;
  pointer-events: none;
  margin-bottom: 10px;
  width: 100%;
  ${desktopOnly`
    transition: margin-right 0.5s, margin-left 0.5s;
    margin-bottom: 20px;
  `}
`;

export const Container = styled.div<{ state: string }>`
  pointer-events: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${SURFACE_6};
  display: flex;
  min-height: 62px;
  width: max-content;
  padding: 20px 30px;
  border-radius: 10px;
  gap: 40px;
  margin-bottom: ${({ state }) => (state === 'entered' ? 0 : -200)}px;
  transition: margin-bottom 0.5s;
  box-shadow: 0px 2px 14px rgba(0, 0, 0, 0.15);
  margin: 0 30px;
  ${mobileOnly`
    margin: 0 10px;
    flex-direction: column;
    gap: 20px;
  `}
`;

export const TextWrapper = styled.div`
  ${TEXT_LABEL_M_MEDIUM}
  color: ${TEXT_100};
  display: flex;
  align-items: center;
  ${mobileOnly`
    text-align: center;
  `}
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  max-height: 40px;
  overflow: hidden;
  gap: 10px;
  ${mobileOnly`
    margin-top: 10px;
  `}
`;

const BASE_GDPR_BUTTON_STYLES = css`
  padding: 12px;
  width: 154px;
  height: 40px;
  border-radius: 5px;
`;

export const AcceptButton = styled(Button).attrs((props) => ({
  className: SUBMIT,
}))`
  ${TEXT_LABEL_M_BOLD}
  color: ${TEXT_CONTRAST_ON_ACCENT_PRIMARY};
  background: ${ACCENT_PRIMARY};
  ${BASE_GDPR_BUTTON_STYLES}
`;

export const RejectButton = styled(Button).attrs((props) => ({
  className: REJECT,
}))`
  ${TEXT_LABEL_M_BOLD}
  background: ${HIGHLIGHT_PRIMARY};
  color: ${TEXT_CONTRAST_ON_HIGHLIGHT_PRIMARY} !important;
  :hover {
    background: ${HIGHLIGHT_PRIMARY};
  }
  ${BASE_GDPR_BUTTON_STYLES}
`;

export const StyledLink = styled(Link)`
  color: ${ACCENT_PRIMARY};
`;
